import ReactDOM from 'react-dom/client';
import { Route, Routes, HashRouter } from 'react-router-dom';

import './styles/index.css'
import './styles/colorThemes.css'
import './styles/fonts.css'

import App from './App';
import Templates from './pages/MainPages/Templates';
import Edit from './pages/MainPages/Edit';
import Documents from './pages/MainPages/Documents';
import Profile from './pages/MainPages/Profile';
import Help from './pages/MainPages/Help';

import Success from './pages/OtherPages/Success';
import Failed from './pages/OtherPages/Failed';
import { Error } from './pages/OtherPages/Error';

import { ErrorBoundary } from 'react-error-boundary'




const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <HashRouter>
    <ErrorBoundary fallback={<Error />}>
      <Routes>
          <Route path='/' element={<App />} >
            <Route index element={<Templates />} />
            <Route path='/edit' element={<Edit />} />
            <Route path='/documents' element={<Documents />} />
            <Route path='/profile' element={<Profile />} />
            <Route path='/help' element={<Help />} />
          </Route>
          <Route path='/success' element={<Success />} />
          <Route path='/failed' element={<Failed />} />
      </Routes>
    </ErrorBoundary>
  </HashRouter>
);